const React = require('react');
const {
  getRFC3339,
} = require('mn-utils/formatTime');
const formatTime = require('../../../../utils/formatTime');
const formatNumCoin = require('../../../../utils/formatNumCoin');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');
const ButtonUp = require('../../../dumb/Button/Up');
const Tooltip = require('../../../dumb/Tooltip/A');
const RowA = require('../../../dumb/Row/A');
const RowB = require('../../../dumb/Row/B');
const ColA = require('../../../dumb/Col/A');
const ColB = require('../../../dumb/Col/B');


module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  rowHeight: 70,
  request: require('../../../../api/admin/arbitrageDeposits')
      .apiAdminArbitrageDepositsList,
  wrapper(render, setState, self) {
    function Item({
      data,
    }) {
      const id = data.id || '';
      const login = data.login || '';
      const scAmount = data.sc_amount || 0;
      const time = data.created_at || '';
      return (
        <RowA>
          <ColA className="wmin100 fx1">
            <Tooltip>{id}</Tooltip>
          </ColA>
          <ColA className="w(|min)150">
            <Tooltip>{login}</Tooltip>
          </ColA>
          <ColA className="w(|min)150">
            <Tooltip
              title={getRFC3339(time)}
            >{formatTime(time)}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip>{data.sc_code}</Tooltip>
          </ColA>
          <ColA className="w(|min)100">
            <Tooltip
              title={scAmount}
            >{formatNumCoin(scAmount)}</Tooltip>
          </ColA>
        </RowA>
      );
    }

    return (state) => {
      return (
        <LayoutA>
          <HeaderA>
            <CaptionA>Arbitrage deposits</CaptionA>
          </HeaderA>
          <div className="abs st70 sh-45 sb10 ov">
            <div className="ovxA abs s ph45 pb80">
              <div className="wmin800 rlv h">
                <div>
                  <RowB>
                    <ColB className="wmin100 fx1">id</ColB>
                    <ColB className="w(|min)150">login</ColB>
                    <ColB className="w(|min)150">Created at</ColB>
                    <ColB className="w(|min)100">SC code</ColB>
                    <ColB className="w(|min)100">SC amount</ColB>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(Item)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={state.showUp}
              onClick={self.handleToUp}
            />
          </div>
        </LayoutA>
      );
    };
  },
});
